module.exports = __webpack_public_path__ + "static/media/CHAWM_MENU-normal.ed7af45a.png";